import { render } from "./App.vue?vue&type=template&id=5efa721c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5efa721c&scss=true&lang=css"

import exportComponent from "D:\\Project\\skin-web\\觉醒大冒险\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__